import {Component, OnInit} from '@angular/core';
import {Observable, catchError, map, tap, throwError, timeout, BehaviorSubject} from 'rxjs';
import {GlossaryEntries, GlossaryEntry} from 'src/app/model/types';
import {ApiService} from 'src/app/services/api/api.service';
import {BreadcrumbsService} from '../../services/breadcrumbs/breadcrumbs.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-glossary-page',
  templateUrl: './glossary-page.component.html',
  styleUrls: ['./glossary-page.component.scss']
})
export class GlossaryPageComponent implements OnInit {
  public selectedCharacter = 'a';
  public availableChar:string[]=[];
  public glossaryEntries:GlossaryEntry[]= [];
  public availableChars$: BehaviorSubject<string[]>= new BehaviorSubject<string[]>(this.availableChar);
  public glossary:GlossaryEntries = {};
  public glossary$:BehaviorSubject<GlossaryEntries>= new BehaviorSubject<GlossaryEntries>(this.glossary);
  public glossaryEntries$: BehaviorSubject<GlossaryEntry[]>= new BehaviorSubject<GlossaryEntry[]>(this.glossaryEntries);
  public breadcrumbLabel = $localize`:glossary-page|breadcrumb-text-link@@glossary-page.breadcrumb-text:Glossario`;
  private loading$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public loading$ = this.loading$$.asObservable();
  public lang:string="it";

 // public glossaryEntries?:GlossaryEntries;
  //public selectedCharacters?:[];
  constructor(private apiService: ApiService,
              private breadcrumbService: BreadcrumbsService,
              private router : Router) {
  }

  ngOnInit(): void {
  this.langSubscribe();
    //this.glossaryEntries$ = this.apiService.getGlossaryEntry(this.selectedCharacter,this.lang);
   /* this.availableChars$ = this.apiService.getGlossaryEntries(this.lang)
      .pipe(
        map((glossaryEntries: GlossaryEntries) => Object.keys(glossaryEntries)),
        tap(() => this.loading$$.next(false)
        ),
        
      );*/
      this.apiService.getGlossaryEntries(this.lang).subscribe({
        next:(x)=>{
          if(x){
          this.glossary$.next(x);        
          this.glossaryEntries$.next(x[this.selectedCharacter]);
          this.availableChars$.next(Object.keys(x))
          this.loading$$.next(false);
          this.glossary=x;
           }
           else 
           this.loading$$.next(false);
        },
        error:() => {
          this.loading$$.next(false);
         
        }
  })
  
 
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    this.breadcrumbService.pushUrl({label: this.breadcrumbLabel, routerLink: '/glossario'});
  }
 /* public glossarySub(){
    this.glossary$.subscribe({
      next:(x)=>{
        this.glossaryEntries$.next(x[this.selectedCharacter]);
        this.glossary=x;
      }
    });
  } */
  public characterSelectedHandler(character: string): void {
    
    this.loading$$.next(true);
    this.selectedCharacter = character;
   this.glossaryEntries$.next(this.glossary[this.selectedCharacter])
    this.loading$$.next(false);
    

  }

  langSubscribe(): void {
   
      let url = window.location.href
      if (url.endsWith('/en') || url.includes('/en/')){
        this.lang = 'en'
      }
      if (url.endsWith('/it') || url.includes('/it/')){
        this.lang = 'it'
      }
    
  }
}
